module.exports = __webpack_public_path__ + "assets/img/al6.37363102.jpg";